export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PORT = process.env.PORT;
export const ENV = process.env.REACT_APP_ENV;

